// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__3fyBY","crumbs":"index_crumbs__u6WRO","fix":"index_fix__YaDQf","btn":"index_btn__9t_Oj"};